import { createAsyncThunk } from '@reduxjs/toolkit';
import Raven from 'raven-js';
import { deleteThread } from '../api/threadsApi';
export const copilotV2DeleteThread = createAsyncThunk('threads/copilotV2DeleteThread', async (args, {
  rejectWithValue
}) => {
  try {
    await deleteThread(args);
  } catch (error) {
    Raven.captureException(error instanceof Error ? error : new Error(String(error)), {
      extra: {
        component: 'copilotV2DeleteThread',
        action: 'copilotV2DeleteThread',
        copilotVersion: '2'
      }
    });
    return rejectWithValue(error instanceof Error ? error.message : 'Failed to get latest or create thread');
  }
});